// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingAnimation_diet_container__39SYd","logo":"LoadingAnimation_diet_logo__NTlHf","text":"LoadingAnimation_diet_text__2bXe6"};